import { ElementType, Planet } from '@apeiron/planet'
import { noForwardCustomProps } from '@apeiron/temp'
import { Box, styled } from '@mui/material'
import { mappingElementColor } from '@src/components/planet/detail/planetElementSection/PlanetElementSection'
import React from 'react'
import { useTranslation } from 'react-i18next'

const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  margin-left: 22px;
  justify-content: center;
  margin-bottom: -8px;
`

const Square = styled(Box, noForwardCustomProps(['elementType']))<{
  elementType: ElementType
}>`
  width: 8px;
  height: 8px;
  background-color: ${props => mappingElementColor[props.elementType]};
  transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
`

const ElementText = styled(Box)`
  font-size: 16px;
  line-height: 16px;
  color: #ffffff;
  margin-left: 6px;
`

const ElementTextContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 8px;
`

export const PlanetElementText: React.FC<PlanetElementTextProps> = props => {
  const { planet } = props

  const { t } = useTranslation()

  return (
    <Container>
      <ElementTextContainer>
        <Square elementType={ElementType.Fire} />
        <ElementText>
          {t('element.fire')} - {planet.fire}%
        </ElementText>
      </ElementTextContainer>
      <ElementTextContainer>
        <Square elementType={ElementType.Water} />
        <ElementText>
          {t('element.water')} - {planet.water}%
        </ElementText>
      </ElementTextContainer>
      <ElementTextContainer>
        <Square elementType={ElementType.Air} />
        <ElementText>
          {t('element.air')} - {planet.air}%
        </ElementText>
      </ElementTextContainer>
      <ElementTextContainer>
        <Square elementType={ElementType.Earth} />
        <ElementText>
          {t('element.earth')} - {planet.earth}%
        </ElementText>
      </ElementTextContainer>
    </Container>
  )
}

export type PlanetElementTextProps = {
  planet: Planet
}
